import type { FeatureCollection, MultiLineString } from 'geojson';
import packed from './country-borders.json' with { type: 'json' };
import packed110m from './country-borders-110m.json' with { type: 'json' };
import packed50m from './country-borders-50m.json' with { type: 'json' };
import { decodePolyline } from './core.ts';

function decodeBorders(data: {
  readonly features: readonly {
    readonly left?: string;
    readonly right?: string;
    readonly kind: string;
    readonly lines: readonly string[];
  }[];
}): FeatureCollection<MultiLineString> {
  return {
    type: 'FeatureCollection',
    features: data.features.map(
      ({
        left,
        right,
        kind,
        lines,
      }: {
        readonly left?: string;
        readonly right?: string;
        readonly kind: string;
        readonly lines: readonly string[];
      }) => ({
        type: 'Feature',
        properties: { left, right, kind, type: 'Land' },
        geometry: {
          type: 'MultiLineString',
          coordinates: lines.map((line) => decodePolyline(line).map(([lat, lon]) => [lon, lat])),
        },
      }),
    ),
  };
}

export const COUNTRY_BORDERS = decodeBorders(packed);
export const COUNTRY_BORDERS_110M = decodeBorders(packed110m);
export const COUNTRY_BORDERS_50M = decodeBorders(packed50m);
